// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import type { RootState } from "@/store";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URI,
  prepareHeaders: async (headers, { getState, endpoint }) => {
    const token = (getState() as RootState).auth.token;

    if (token && endpoint !== "downloadCompanyFile") {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  tagTypes: [
    "Me",
    "Users",
    "UserNotes",
    "Companies",
    "UserCompanies",
    "CompanyStatuses",
    "CompanyStatusPermissions",
    "CompanyCourseStatuses",
    "Opcos",
    "Organisations",
    "People",
    "PersonNotes",
    "Autocomplete",
    "Courses",
    "CompanyCourses",
    "Instructors",
    "CompanyCourseNote",
    "CompanyNotes",
    "CompanyPeople",
    "CompanyCoursePeople",
    "UserMeetings",
    "CompanyMeetings",
    "CommercialBooking",
    "CompanyUsers",
    "CompanyFiles",
    "Meetings",
    "InstructorNotes",
    "HolidaySchedules",
    "UserCommissions",
    "CompanyCourseCommissions",
    "CommissionStats",
    "CompanyCourseInstructors",
    "CompanyCourseInstructorInvoices",
    "TrainingBrochures",
    "CompanyEmails",
    "EmailTemplates",
    "ActivitySectors",
    "Teams",
    "TeamUsers",
    "CalendarVisibilities",
    "MyCalendarVisibilities",
    "SignedConventionStats",
    "DashboardStats",
    "SoftphoneLines",
    "MySoftphoneLine",
    "CallLogs",
    "MontageMeetings",
    "MontageMeetingStatuses",
    "PreformatifDiagnostics",
    "ActionJobs",
    "Availabilities",
    "Holidays",
  ],
  baseQuery,
  endpoints: () => ({}),
  refetchOnFocus: true,
});

export default api;
